module.exports = __webpack_public_path__ + "img/limited.9d2ed742.svg";